// extracted by mini-css-extract-plugin
export default {"check":"check-toggle_check__FrbGq","check-black":"check-toggle_check-black__ch7UJ"};